// extracted by mini-css-extract-plugin
export default {"Switch":"Switch__noH6_v17-8-1","Switch__Flat":"Switch__Flat_Aak_j_v17-8-1","Switch__Tiny":"Switch__Tiny___f6f_v17-8-1"};